<template>
  <!-- BEGIN: Header-->
  <nav
    class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-semi-light bg-dion navbar-shadow"
  >
    <div class="navbar-wrapper">
      <div class="navbar-header">
        <ul class="nav navbar-nav flex-row">
          <li class="nav-item mobile-menu d-md-none mr-auto">
            <a
              class="nav-link nav-menu-main menu-toggle hidden-xs"
              href="#"
              @click="menuToggle"
            >
              <menu-icon
                size="1.5x"
                class="custom-class"
                style="font-size: 1.5rem!important;"
              ></menu-icon>
            </a>
          </li>
          <li class="nav-item">
            <router-link class="navbar-brand" to="/">
              <!-- <img class="brand-logo" alt="modern admin logo" src=""> -->
              <!-- <img src="@/assets/img/UK-DION-LOGISTICS-LOGO-01.png" alt="" style="width: 30px;" v-if="brand == 'DION LOGISTICS'"> -->
              <h3 class="brand-text text-capitalize">{{ brand }}</h3>
            </router-link>
          </li>
          <li class="nav-item d-md-none dropdown dropdown-user">
            <a
              class="nav-link open-navbar-container dropdown-toggle dropdown-user-link"
              data-target="#navbar-mobile"
              data-toggle="dropdown"
              id="mobile-user"
              @click="userDropdown('mobile-user')"
            >
              <span class="avatar avatar-online">
                <img src="" alt="avatar" />
                <i></i>
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <router-link
                :to="{ name: 'Profile' }"
                class="dropdown-item text-primary"
              >
                <i class="ft-user"></i> Password Settings
              </router-link>

              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click.prevent="logOut">
                <i class="ft-power"></i> Logout
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div
        class="navbar-container content d-none d-md-block"
        style="height: 4.15rem;"
      >
        <div
          class="collapse navbar-collapse"
          id="navbar-mobile"
          style="height: -webkit-fill-available;"
        >
          <ul class="nav navbar-nav mr-auto float-left">
            <li class="nav-item d-none d-md-block">
              <a
                class="nav-link nav-menu-main menu-toggle hidden-xs"
                href="#"
                @click="collapseMenuToggle"
              >
                <menu-icon size="1.5x" class="custom-class"></menu-icon>
              </a>
            </li>
          </ul>
          <ul class="nav navbar-nav float-right">
            <li class="dropdown dropdown-user nav-item">
              <a
                class="dropdown-toggle nav-link dropdown-user-link"
                href="#"
                data-toggle="dropdown"
                id="web-user"
                @click="userDropdown('web-user')"
              >
                <span class="mr-1 user-name text-bold-700">{{
                  this.userObj.name
                }}</span>
                <span class="avatar avatar-online">
                  <!--<img v-if="userObj.admin" :src="userObj.admin.avatar">
                                    <img v-else-if="userObj.business" :src="userObj.business.avatar">-->
                  <img src="https://via.placeholder.com/150" />
                  <i></i>
                </span>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <router-link
                  :to="{ name: 'Profile' }"
                  class="dropdown-item text-primary"
                >
                  <i class="ft-user"></i> Edit Profile
                </router-link>

                <div class="dropdown-divider"></div>
                <a class="dropdown-item" @click.prevent="logOut">
                  <i class="ft-power"></i> Logout
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- {{ userObj }} -->
  </nav>
  <!-- END: Header-->
</template>

<script>
import { MenuIcon, MoreVerticalIcon } from "vue-feather-icons";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Header",
  components: {
    MenuIcon,
    MoreVerticalIcon
  },
  data() {
    return {
      brand: ""
    };
  },
  methods: {
    ...mapActions(["logoutUser"]),
    collapseMenuToggle() {
      let body = document.querySelector(".fixed-navbar");
      body.classList.toggle("menu-collapsed");
    },
    menuToggle() {
      let body = document.querySelector(".fixed-navbar");
      let overlay = document.querySelector(".sidenav-overlay");

      if (
        body.classList.contains("menu-hide") &&
        overlay.classList.contains("d-none")
      ) {
        body.classList.remove("menu-hide");
        body.classList.add("menu-open");

        overlay.classList.remove("d-none");
        overlay.classList.add("d-block");
      } else {
        body.classList.add("menu-hide");
        body.classList.remove("menu-open");

        overlay.classList.remove("d-block");
        overlay.classList.add("d-none");
      }
    },
    userDropdown(target) {
      let element = document.querySelector(`#${target}`);
      element.parentElement.classList.toggle("show");
      element.nextElementSibling.classList.toggle("show");
    },
    logOut() {
      this.logoutUser();
    }
  },
  computed: {
    ...mapGetters(["userObj"])
  },
  mounted() {
    console.log(this.userObj);
    this.brand = process.env.VUE_APP_BRANDNAME;
  }
};
</script>

<style>
.bg-dion {
  background: #32417e !important;
}
</style>
